export const getCorrectImageBase64Format = (image: string) =>
  image.startsWith('data') ? image.slice(image.indexOf(',') + 1) : image;

export const getCorrectImageBase64FormatArray = (image: string[]) =>
  image?.map((d) => getCorrectImageBase64Format(d));
